import { settings } from "@alme/ui-web/settings/settings-util";
import { AlmeUIResponse } from "@alme/ui-web/types/response";
import ResponseActionHandler from "@alme/ui-web/types/response-action-handler";
import {AlmeResponseV5} from '@alme/types/response/AlmeResponse';

export default class ResponseProcessorDebugHandler extends ResponseActionHandler{
    constructor(passedSettings?: typeof settings) {
        super(["ConverseRequest", "AppeventRequest"], ["DebugResponseAction"], passedSettings);
    }

    processResponse(response: AlmeUIResponse): AlmeUIResponse {
        const almeV5Response = response as AlmeResponseV5;
        const responseActions = this.getResponseActions(almeV5Response);

        if(responseActions.some(action => action.Name === "DebugResponseAction")){
            try{
                if(almeV5Response.text){
                    console.log(JSON.parse(`{ "response": ${almeV5Response.text} }`));
                }
                else{
                    console.warn("No debug data found to log.");
                }
            }catch(ex){
                console.error(`Could not parse JSON from almeV5Response.text: ${ex}`);
            }

        }

        return response;
    }

}


// WEBPACK FOOTER //
// ./modules/response-processor-debug/response-processor-debug.ts